import  useNavigation from '../../../hooks/useNavigation.js'
export const cryptoConfigColumns = () => {
    const { navigateTo } = useNavigation();

    return[
  
   
        {
          name: 'Crypto Code',
          selector: row =>  <div className="custom-cell-order_Code">{row.crypto_code}</div>,
          sortable: true,
          //style: row => ({ minWidth: '100px' }),
        },
        {
          name: 'Buy Rate',
          //selector: row => row.email_address,
          cell: row =>  '₹' + row.buy_rate,
          sortable: true,
         // style: row => ({ minWidth: '100px' }),
        },
       
        {
          name: 'Sell Rate',
          //selector: row => row.email_address,
          cell: row =>'₹' + row.sell_rate ,
          sortable: true,
         // style: row => ({ minWidth: '100px' }),
        },
        {
          name: 'Min Quantity',
          //selector: row => row.email_address,
          cell: row => row.min_quantity ,
          sortable: true,
         // style: row => ({ minWidth: '100px' }),
        },
        {
          name: 'Max Quantity',
          //selector: row => row.email_address,
          cell: row =>row.max_quantity,
          sortable: true,
         // style: row => ({ minWidth: '100px' }),
        },
        
        {
          name: "Actions",
          button: true,
         
          cell: row =>
           <>
    
            <a className={`fview tooltip`} style={{'cursor':'pointer'}}  onClick={() => navigateTo('EditCrypto','edit-crypto-config',row.id)}>
             <i className={`fa fa-edit`} style={{'color':'black'}}/>
              <span className="tooltiptext">Edit</span>
            </a>
            <>
            {/* <a className="tooltip dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              <i className="fa fa-ellipsis-v" aria-hidden="true"  style={{color:'black'}}/>
              <span className="tooltiptext">More</span>
            </a> */}
           </> {/* <ul className="dropdown-menu transaction dropdown-menu-end mbv" id="nvb" aria-labelledby="navbarDropdown">
              <li onClick={() => {
              updateImages(row.id);
            }}>
                <a className="dropdown-item"  style={{cursor:'pointer',fontSize: '13px'}}>Update Images</a>
              </li>
             
            </ul> */}
             
              
              </>
       
        }
      ];
  }
  